import ListItemButton from "@mui/material/ListItemButton";

import {
  ListItemIcon,
  ListItemText,
} from "layouts/Flow Designer/components/Titlebar/components/TitlebarActions/StyledComponents";

const SqlButton = ({ onClick, icon, text, disabled, sx = {} }) => {
  return (
    <ListItemButton onClick={onClick} disabled={disabled} sx={{ borderRadius: "9px", ...sx }}>
      <ListItemIcon>
        {icon}
        <ListItemText primary={text}></ListItemText>
      </ListItemIcon>
    </ListItemButton>
  );
};

export default SqlButton;
